export default {
  GLOFAS_USER: "glofas-user",
  EFAS_USER: "efas-user",
  GFM_USER: "gfm-user"
}